import { useState } from 'react';

import type { ThematicMeeting } from '@/types/thematic-meetings';

import { MeetingDateModal } from '@/pages/ThematicMeetings/Plan/components/MeetingDateModal';
import { MeetingStatusPill } from '@/pages/ThematicMeetings/Plan/components/MeetingStatusPill';

interface MeetingDateFieldProps {
    meeting: ThematicMeeting;
}

/**
 * The meeting's status and date, in the header's top-right corner, with the dialog that moves it.
 * A completed meeting keeps the pill alone — `MeetingStatusPill` drops the button itself.
 */
export const MeetingDateField = ({ meeting }: MeetingDateFieldProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <MeetingStatusPill
                meeting={meeting}
                onEditDate={() => setIsModalOpen(true)}
            />

            {isModalOpen && (
                <MeetingDateModal
                    meeting={meeting}
                    onClose={() => setIsModalOpen(false)}
                />
            )}
        </>
    );
};
